import { render } from "./Facet.vue?vue&type=template&id=71329832"
import script from "./Facet.vue?vue&type=script&lang=js"
export * from "./Facet.vue?vue&type=script&lang=js"

import exportComponent from "/opt/approot/build.20261030-093834-708061d9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__